import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { DrofusForekomstDetailsModal } from "../DrofusForekomster/DrofusForekomstDetailsModal";
import { DrofusOccurrenceChangesTable } from "./DrofusOccurrenceChangesTable";
import {
  closeDrofusEndringerOccurrenceDetails,
  setDrofusEndringerLimit,
  setDrofusEndringerOffset,
} from "./drofusEndringerSlice";
import {
  selectDrofusEndringerApiArg,
  selectDrofusEndringerPagination,
  selectDrofusEndringerSelectedOccurrenceRef,
} from "./drofusEndringerSelectors";

export const DrofusEndringerTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const apiArg = useAppSelector(selectDrofusEndringerApiArg);
  const pagination = useAppSelector(selectDrofusEndringerPagination);
  const occurrenceRef = useAppSelector(selectDrofusEndringerSelectedOccurrenceRef);
  const {
    currentData: data,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = openapi.usePostMultiplacerDrofusInterfaceProjectChangeEventsQuery(apiArg ?? skipToken);
  return (
    <>
      <DrofusForekomstDetailsModal
        occurrenceRef={occurrenceRef}
        opened={occurrenceRef != null}
        onClose={() => dispatch(closeDrofusEndringerOccurrenceDetails())}
      />
      <DrofusOccurrenceChangesTable
        items={data?.items ?? []}
        total={data?.total ?? 0}
        offset={apiArg?.body.offset ?? 0}
        limit={apiArg?.body.limit ?? pagination.limit}
        isLoading={isLoading}
        isFetching={isFetching}
        isError={isError}
        enabled={Boolean(apiArg)}
        stateKey="drofus-endringer-comparison"
        onPageChange={(page) => dispatch(setDrofusEndringerOffset((page - 1) * pagination.limit))}
        onLimitChange={(limit) => dispatch(setDrofusEndringerLimit(limit))}
        onRetry={refetch}
      />
    </>
  );
};
